import { centerAligned } from '@medly-components/utils';
import styled, { css } from 'styled-components';
import blueWave from '../../../assets/svg/blue-wave.svg';
import yellowWave from '../../../assets/svg/yellow-wave.svg';
import { PageContentProps } from './types';

const waveStyle = css<PageContentProps>`
    @media (min-width: ${({ theme }) => theme.breakpoints.L.min}px) {
        background-image: url(${({ wave }) => (wave === 'blue' ? blueWave : yellowWave)});
        background-repeat: no-repeat;
        background-position: ${({ shiftWaveBehindFooter }) => (shiftWaveBehindFooter ? '100% calc(100% + 7.2rem)' : 'right bottom')};
        background-size: 40%;
    }
`;

export const PageContent = styled('main')<PageContentProps>`
    box-sizing: border-box;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.grey[100]};
    overflow: auto;
    padding: 2.4rem;
    position: relative;
    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        padding: 4rem;
    }
    ${({ wave }) => wave && waveStyle}
`;

export const Loader = styled('div')`
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 5;
    ${centerAligned('flex')}
`;
